import { render, staticRenderFns } from "./GeoStats.vue?vue&type=template&id=2a8ca4ac&scoped=true&"
import script from "./GeoStats.vue?vue&type=script&lang=js&"
export * from "./GeoStats.vue?vue&type=script&lang=js&"
import style0 from "./GeoStats.vue?vue&type=style&index=0&id=2a8ca4ac&prod&lang=scss&"
import style1 from "./GeoStats.vue?vue&type=style&index=1&id=2a8ca4ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8ca4ac",
  null
  
)

export default component.exports